import { useQuery } from "@tanstack/react-query";
import * as API from "../../networking/policies";
import { Policy } from "../../redux/reducers/types/commonTypes";
import { PaginatedListViewParams } from "../../networking/commonTypes";

export const useUserPolicies = () => {
    return useQuery<{ results: Policy[] }>({
        queryKey: ["policies", "user"],
        queryFn: async () => {
            const response = await API.getUserPolicies();
            return response.data;
        },
    });
};

export const useAvailablePolicies = (page: number = 1, pageSize: number = 100, hasQuote?: boolean) => {
    return useQuery<{ results: Policy[] }>({
        queryKey: ["policies", "available", page, pageSize, hasQuote],
        queryFn: async () => {
            const params: PaginatedListViewParams = { page, perPage: pageSize };
            if (hasQuote !== undefined) {
                params.has_quote = hasQuote.toString();
            }
            const response = await API.getAvailablePolicies(params);
            return response.data;
        },
    });
};

